import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class BorderouService {
    private token!: string;
    private httpOptions: any;
    isLoading = true;
    private basePath = environment.interop.basePath;

    private getDTUrl =
        this.basePath + environment.interop.indoc.borderou.getBorderouDT;

    private storeUrl =
        this.basePath + environment.interop.indoc.borderou.storeBorderou;

    private storeMultipleUrl =
        this.basePath + environment.interop.indoc.borderou.storeMultipleBorderou;

    private createUrl =
        this.basePath + environment.interop.indoc.borderou.createBorderou;

    private cancelUrl =
        this.basePath + environment.interop.indoc.borderou.cancelBorderou;

    private viewUrl =
        this.basePath + environment.interop.indoc.borderou.viewBorderou;

    public printUrl =
        this.basePath + environment.interop.indoc.borderou.printBorderou;

    constructor(private http: HttpClient) { }

    getDT() {
        return this.http.get(this.getDTUrl, this.httpOptions);
    }

    store(payload: any) {
        return this.http.post(this.storeUrl, payload, this.httpOptions);
    }

    storeMultiple(payload: any) {
        return this.http.post(this.storeMultipleUrl, payload, this.httpOptions);
    }

    view(id: number) {
        return this.http.get(this.viewUrl + id);
    }

    cancel(id: number, motiv: string) {
        return this.http.post(this.cancelUrl + id, { motiv: motiv }, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
